import React from "react";

import {
    PopupTitle,
    PopupContainer,
    PopupButtonsContainer,
    PopupButton
} from "../JobBoardDetails.styles";

interface AdditionalActionsProps {
    onEdit: () => void
    onDelete: () => void
}

const AdditionalActions = ({onEdit, onDelete}: AdditionalActionsProps) => {
    return (
        <PopupContainer>
            <PopupTitle>Job Posting Actions</PopupTitle>
            <PopupButtonsContainer>
                <PopupButton
                    variant="contained"
                    onClick={onEdit}
                    color="primary"
                    size="large"
                    id="review-button"
                    className="bigButtonInNewStyle"
                >
                    Edit Job
                </PopupButton>
                <PopupButton
                    variant="contained"
                    onClick={onDelete}
                    color="primary"
                    size="large"
                    id="review-button"
                    className="bigButtonInNewStyle"
                >
                    Delete Job
                </PopupButton>
            </PopupButtonsContainer>
        </PopupContainer>
    );
}

export default AdditionalActions;
